import './styles.css';
import { renderTitle } from './screens/title';
import { renderBuilder } from './screens/builder';
import { renderBattle } from './screens/battle';
import type { Character } from './data/types';

const root = document.getElementById('app')!;

function showTitle() {
  renderTitle(root, showBuilder);
}

function showBuilder() {
  renderBuilder(root, (left, right) => showBattle(left, right));
}

function showBattle(left: Character[], right: Character[]) {
  renderBattle(root, left, right, showBuilder);
}

showTitle();

// Surface uncaught errors so the Chrome debug pass picks them up.
window.addEventListener('error', (e) => {
  console.error('[BattleBrawl] uncaught:', e.error || e.message);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('[BattleBrawl] unhandled rejection:', e.reason);
});
